import { SearchBox, Stack, TextField,TooltipHost } from "@fluentui/react";
import React, { useRef, useEffect, useContext, useState } from "react";
import studyReportContext from "../../../../context/studyreport/StudyReportContext";
import studyviewerContext from "../../../../context/studyviewer/StudyviewerContext";
import {
  downloadPdfReport,
  getAllPathologies,
} from "../../../../service/StudyReportService";
import { DefaultPalette } from "@fluentui/react/lib/Styling";
import MicIcon from "../../../../components/SVGComponents/MicIcon";
import AnnotationContext from "../../../../context/annotation/AnnotationContext";
import { t } from "i18next";
import CustomToolTipHost from "../../../../components/CustomToolTipHost/CustomToolTipHost";
import themeContext from "../../../../context/theme/ThemeContext";
import ViewportContext from "../../../../context/studyviewer/ViewportContext";

const AnnotationBox = (props) => {
  const ref = useRef(null);
  const { onClickOutside } = props;
  const [allAnno, setAllAnno] = useState([]);
  const [allAnnoStore, setAllAnnoStore] = useState([]);
  const { getAlterColor, theme } = useContext(themeContext);
  const { allAnnotations,addOrRemoveAnnotation,searchInputValue,setSearchInputValue,
    setAllAnnotation,addStudyAnnotation,allStoreAnnotations, setAllStoreAnnotations, annotationState, addedAnnotation } = useContext(AnnotationContext);
  const {showFindingsHighlighted,
    showProbablilityScores, showAboveThresholdScore} = useContext(studyviewerContext)
    const {setActiveTool} = useContext(ViewportContext);
  useEffect(() => {
    //console.log("--- All Annotation ----",allAnnotations);
    // setAllAnnotation(allStoreAnnotations);
    // setAllStoreAnnotations(allStoreAnnotations);
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        onClickOutside && onClickOutside();
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, [onClickOutside]);

  useEffect(()=>{
    if(props.show && annotationState.annotations_stuff?.length > 0){
      setAllAnno(annotationState.annotations_stuff);
      setAllAnnoStore(annotationState.annotations_stuff);
    }
  },[props.show])

  if (!props.show) return null;

  const searchStyle = {
    root: {width:'182px' },
  };

  const tooltipStyle = {
    root: {display:'flex',alignItems:'center' },
  };

  const filterList = (searchInput) => {
    if(searchInput != null && searchInput != undefined)searchInput = searchInput.trim();
    // console.log(searchInput);
    let searchValue = searchInput.toLowerCase();
    let allTemp = annotationState.annotations_stuff;
    if (searchValue != "") {
      const filteredData = allTemp.filter((item) => {
        return item.name.toLowerCase().includes(searchValue);
      });
      // console.log(filteredData);
      setAllAnno(filteredData);
    } else {
      setAllAnno(annotationState.annotations_stuff);
    }
  };

  return (
    <div onClick={(ev)=>{ev.stopPropagation()}} ref={ref} className="patalogy-options">
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div style={{ width: "230px" }}>
          <SearchBox
            placeholder={t("placeholder.search")}
            autoFocus={true}
            styles={searchStyle}
            onClear={(ev) => {
              ev.stopPropagation();
            }}
            onChange={(ev, newValue) => {ev?.stopPropagation();filterList(newValue);}}
          />
        </div>
        {/* <div style={{ display: "flex", alignItems: "center", float: "right" }}>
          <MicIcon />
        </div> */}
      </div>
      <ul className="dropdown-menu-pathology scrollable-menu modal-scroll-annotation">
        {allAnno.length > 0 ? (
          allAnno.map((pathology, index) => {
            return (
              <li
               style={{
                cursor : `${addedAnnotation.some((item)=>item.id == pathology.id)? 'not-allowed': 'pointer'}`,
                backgroundColor: `${addedAnnotation.some((item)=>item.id == pathology.id) ? theme.palette.actionDetailsHover : ''}`,
                borderRadius: `${addedAnnotation.some((item)=>item.id == pathology.id) ? '0px' : '10px'}`
              }}
                key={pathology.id}
                onClick={(event) => {
                  // setActiveTool("RectangleROI");
                  event.stopPropagation();
                  if(addedAnnotation.some((item)=>item.id == pathology.id)){
                    return;
                  }
                 


                  props.setShowPathologyOptions(true);
                  addStudyAnnotation(pathology.id);
                  props.setShowInfo1(false);
                }}
              >
                <a id={pathology.id} 
                style={{display:'flex',
                  }}>
                  
                  <>
                    <div className="classification-pathology" style= {{boxSizing:'border-box', fontWeight: `${showFindingsHighlighted && pathology.ai_predicted == 1 ? 'bold':''}`}} >
                      <span className="viewer-li-text" 
                        style={{
                          color: 
                              `${showFindingsHighlighted && addedAnnotation.some((item)=>item.id == pathology.id)
                                ? pathology.ai_predicted == 1 
                                  ? getAlterColor("rgb(255,255,255)","#000")
                                    : getAlterColor("rgb(255,255,255)","#000")
                                  : pathology.ai_predicted == 1 
                                    ? getAlterColor("rgb(255,255,255)","#000")
                                    :getAlterColor("rgba(255,255,255,0.7)","#000")}` , 
                                  display:'inline-block',
                                  width:'170px'
                                }}
                              >
                                {pathology.name}
                                </span>
                        {showProbablilityScores && <span style ={{color: 
                              `${showFindingsHighlighted && addedAnnotation.some((item)=>item.id == pathology.id)?pathology.ai_predicted == 1 ? getAlterColor("rgb(255,255,255)","#000"): getAlterColor("rgb(255,255,255)","#000"):  pathology.ai_predicted == 1 ? getAlterColor("rgb(255,255,255)","#000"):getAlterColor("rgba(255,255,255,0.7)","#000")}`, paddingRight: "20px"}}>{`${pathology.prediction === null ? "" : showAboveThresholdScore ? 
                                (pathology.prediction > pathology.threshold ? (pathology.prediction*100).toFixed(0)+"%": ''):(pathology.prediction*100).toFixed(0)+"%" }`}</span>}
                    </div>
                  </>
                  </a>
              </li>
            );
          })
        ) : (
          <li className="no-result">
            <a>{t("search-message.no-result")}</a>
          </li>
        )}
      </ul>
    </div>
  );
};

export default AnnotationBox;
